var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopologyMgt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.502 12.435h-1.857v-1.856c-.001-.69-.56-1.25-1.25-1.25h-3.77V7.444h1.873c.69-.001 1.25-.56 1.25-1.25V3.14c0-.69-.56-1.249-1.25-1.25h-4.99c-.69.001-1.25.56-1.25 1.25v3.054c0 .69.56 1.249 1.25 1.25h1.867V9.33h-3.75c-.69 0-1.25.56-1.25 1.25v1.855H2.5c-.69.001-1.25.56-1.25 1.25v3.136c0 .69.56 1.249 1.25 1.25h4.988c.69-.001 1.25-.56 1.25-1.25v-3.136c0-.69-.56-1.25-1.25-1.25H5.623V10.58l.002-.001h8.768v1.855h-1.881c-.69 0-1.25.56-1.25 1.25v3.136c0 .69.56 1.249 1.25 1.25h4.99c.69-.001 1.25-.56 1.25-1.25v-3.136c0-.69-.56-1.25-1.25-1.25zM7.507 6.193V3.142l.001-.002h4.988l.001.002V6.194H7.507v-.001zm-.02 7.493v3.135H2.5l-.001-.002v-3.133l.001-.001h4.987zm10.015 3.133l-.001.002h-4.988l-.001-.002v-3.134H17.502l.001 3.134z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopologyMgt);
export default __webpack_public_path__ + "static/assets/topologyMgt.56a1da86.svg";
export { ForwardRef as ReactComponent };